module.exports = __webpack_public_path__ + "img/pic_4_tc.6bce2979.png";